import React from 'react'
import UpdateInfo from './UpdateInfo'

const Footer = (props) => {
  return (
   <div className="footer">
     <div className="area-texto">
       <UpdateInfo/>
    </div>
   </div>
  )
}

export default Footer


// WEBPACK FOOTER //
// ./src/Footer.js